<template>
  <svg class="icon" :class="className" v-on="$listeners" width="24" height="24">
    <use v-bind="{'href':'/svg-sprite.svg#'+icon}" />
  </svg>
</template>
<script>
export default {
  name: 'BaseIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>
